/** Keep teacher home, week timetable, and demo-week caches in sync after schedule writes. */
export function invalidateTeacherCalendar(queryClient) {
  if (!queryClient) return;
  queryClient.invalidateQueries(['teacherHome']);
  queryClient.invalidateQueries(['teacherHomeCalendarWeek']);
  queryClient.invalidateQueries(['demosByTeacherWeek']);
  queryClient.invalidateQueries(['teacherMyBatches']);
  queryClient.invalidateQueries(['teacherMyBatchesForMakeup']);
}
